import API_URL from '../config';

/**
 * #64 Feature 3 (Sessão 3) — chamadas PÚBLICAS do fornecedor.
 *
 * Usa fetch PURO (não o axios `api`) de propósito: a página /responder
 * é acessada por fornecedor SEM login. Não deve carregar interceptor de
 * auth (Bearer token / refresh-em-401) — desacopla totalmente do fluxo
 * autenticado. O backend (/api/public/*) ignora qualquer header de auth.
 *
 * Erros: lança Error com .status pro componente mapear mensagem
 * (404 link inválido/expirado, 429 rate limit). #74: a resposta deixou de
 * ser single-shot — reabrir e reenviar EDITA (não dá mais 409).
 */

async function _handle(response) {
  if (response.ok) {
    return response.json();
  }
  let detail = '';
  try {
    const body = await response.json();
    detail = body.detail || '';
  } catch {
    // resposta sem body JSON
  }
  const err = new Error(detail || `HTTP ${response.status}`);
  err.status = response.status;
  throw err;
}

export const supplierPublicService = {
  // GET — fornecedor vê a NC (Nível B) e registra abertura.
  verNC: async (token) => {
    const r = await fetch(`${API_URL}/api/public/supplier/${encodeURIComponent(token)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    return _handle(r);
  },

  // POST — fornecedor envia resposta. Camada 1 (#64 qualidade): payload com
  // campos estruturados (causa_identificada, acao_contencao, acao_corretiva,
  // prazo) + resposta_texto (observações). #74: NÃO é mais single-shot —
  // reenviar dentro da janela EDITA (o backend versiona a anterior).
  responder: async (token, payload) => {
    const r = await fetch(
      `${API_URL}/api/public/supplier/${encodeURIComponent(token)}/responder`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }
    );
    return _handle(r);
  },

  // POST — #74 "reenviar meu link": o fornecedor perdeu o link. Manda o email
  // → o backend rotaciona o token dos convites vivos e reenvia o link novo pro
  // próprio endereço. SEMPRE 200 genérico (não revela se o email tem convite).
  recover: async (email) => {
    const r = await fetch(`${API_URL}/api/public/supplier/recover`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    return _handle(r);
  },

  // POST multipart — fornecedor anexa evidência (#64 Camada 2). Público, gated
  // pelo token. Limites do backend: PDF/PNG/JPG, 5 MB, máx 3 (+ teto por
  // convite). NÃO seta Content-Type: o browser põe o boundary do multipart.
  enviarEvidencia: async (token, files) => {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append('arquivos', f));
    const r = await fetch(
      `${API_URL}/api/public/supplier/${encodeURIComponent(token)}/evidencia`,
      { method: 'POST', body: fd }
    );
    return _handle(r);
  },
};

export default supplierPublicService;
